import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField, Button, Grid2 } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { CreateS12ThresholdsAction } from '../actions/DataManagementActions';
import { enqueueSnackbar } from 'actions';

const S12ThresholdsHistoryUpdateForm = () => {
	const userId = useSelector(state => state.session.user.id);
	const dispatch = useDispatch();

	const [fileName, setFileName] = useState('');
	const [selectedFile, setSelectedFile] = useState(null);
	const [isLoading, setIsLoading] = useState(false);

	const handleFileChange = (e) => {
		const file = e.target.files[0];
		if (file) {
			setSelectedFile(file);
			setFileName(file.name);
		}
	};

	const handleSubmit = async () => {
		if (!selectedFile) {
			dispatch(enqueueSnackbar({ message: 'Please select a file.', options: { variant: 'error' } }));
			return;
		}

		const formData = new FormData();
		formData.append('File', selectedFile);
		formData.append('UserId', userId);

		try {
			setIsLoading(true);
			const data = await CreateS12ThresholdsAction(formData);
			dispatch(enqueueSnackbar({ message: data.message, options: { variant: 'success' } }));
			setSelectedFile(null);
			setFileName('');
		} catch (error) {
			dispatch(enqueueSnackbar({ message: `${error}`, options: { variant: 'error' } }));
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<Grid2 container spacing={2}>
			<Grid2 item size={12}>
				<TextField
					label="File Name"
					variant="outlined"
					fullWidth
					InputProps={{ readOnly: true, disabled: true }}
					value={fileName}
				/>
			</Grid2>

			<Grid2 item size={12}>
				<Button
					variant="contained"
					component="label"
					fullWidth
					startIcon={<UploadFileIcon />}
					disabled={isLoading}
				>
					Upload File
					<input type="file" hidden onChange={handleFileChange} />
				</Button>
			</Grid2>

			<Grid2 item size={12}>
				<Button
					variant="contained"
					color="primary"
					fullWidth
					onClick={handleSubmit}
					disabled={isLoading}
				>
					{isLoading ? 'Submitting...' : 'Submit'}
				</Button>
			</Grid2>
		</Grid2>
	);
};

export default S12ThresholdsHistoryUpdateForm;
